module.exports = __webpack_public_path__ + "static/assets/c4105801aadf2606ac304aa7f8a00b97.png";